import React from 'react'

import { withAppStepsState } from "./containers/containerAppStepsState"

import ButtonFill from "./items/controls/buttonFill"

const OpenStepsAppButton = props => {
  const { isOpenAppSteps, onOpenApp } = props

  return (
    <ButtonFill onClick={!isOpenAppSteps ? onOpenApp : () => { }}>
      {props.children}
    </ButtonFill>
  )
}

export default withAppStepsState(OpenStepsAppButton)